import Vue from 'vue';
import VueRouter from 'vue-router';

import { compareRecords, decorateRecords } from 'framework/router/api-helpers.js';
import { dataInserted } from 'framework/router/data-inserted-hook';


export let router;

if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

/**
 * Initialize vue-router
 */
function init(appRoot) {
    const Log = Vue.log({ prefixLocation: 'vue-router' });
    const routes = decorateRecords(appRoot.store, globals.config.router.routes || []);
    const initialRoute = (window.location.pathname + window.location.search);

    router = new VueRouter({
        mode: 'history',
        routes,
        linkActiveClass: 'u-router-link-active',
        linkExactActiveClass: 'u-router-link-exact-active',
        scrollBehavior(from, to, savedPosition) {
            let result = savedPosition || { x: 0, y: 0 };

            return new Promise(resolve => {
                const unregister = dataInserted(() => {
                    Log.debug(`Route transition - Updating scroll state: ${ JSON.stringify(result) }`);

                    if (to.hash && document.getElementById(to.hash)) {
                        result = { selector: to.hash };
                    }

                    resolve(result);
                    unregister();
                });
            });
        },
    });

    // Call hook before every route transition
    router.beforeEach((to, from, next) => {
        Log.debug('beforeEach hook');
        const hasMatches = (to.matched && to.matched.length);
        const areRecorsIdentical = compareRecords(to, from);
        const isInitialRoute = (initialRoute === to.fullPath);

        // Simple link without corresponding route record
        if (!hasMatches && !isInitialRoute) {
            Log.debug('No matches found, following path url');
            window.location.href = to.path;
            return;
        }

        // djangoCMS edit mode
        if (!isInitialRoute && globals.config.cmsEditMode && !areRecorsIdentical) {
            Log.debug('djangoCMS edit mode, following path url');
            window.location.href = to.path;
            return;
        }

        // Registered route record
        Log.debug('Following matched route');
        next();
    });

    // Assign props to the appRoot
    appRoot.router = router;
}

export default init;



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/router/index.js